// Copyright 2025, University of Maryland, All Rights Reserved
import { apiClient } from './api-client'


export interface SessionSettings {
  sync_enabled: boolean
}

export interface DataSourceSyncSettings {
  sessions: {
    [session: string]: SessionSettings
  }
}

export interface GlobalSessionSyncSettings {
  maryland?: DataSourceSyncSettings
  federal?: DataSourceSyncSettings
}

export interface SyncSettings {
  // Data-source-first sync settings structure
  session_sync: GlobalSessionSyncSettings
  updated_at?: string
  updated_by?: string
}

export interface DebugSettings {
  enabled: boolean
  updated_at?: string
  updated_by?: string
}

// Backend now returns snake_case only - no transformation needed

export const adminSettingsApi = {
  // Debug settings
  getDebugSettings: async (): Promise<DebugSettings> => {
    console.log('🔍 Fetching debug settings')
    const response = await apiClient.get<DebugSettings>('/admin/settings/debug')
    console.log('✅ Fetched debug settings:', response.data)
    return response.data
  },

  updateDebugSettings: async (enabled: boolean): Promise<DebugSettings> => {
    console.log(`🔄 Updating debug settings: ${enabled}`)
    const response = await apiClient.post<DebugSettings>(`/admin/settings/debug?enabled=${enabled}`, null)
    console.log('✅ Updated debug settings:', response.data)
    return response.data
  },

  // Sync settings
  getSyncSettings: async (): Promise<SyncSettings> => {
    console.log('🔍 Fetching sync settings')
    const response = await apiClient.get<SyncSettings>('/admin/settings/sync')
    console.log('✅ Fetched sync settings:', response.data)
    return response.data
  },

  updateSyncSettings: async (settings: {
    session_sync: GlobalSessionSyncSettings
  }): Promise<SyncSettings> => {
    console.log('🔄 Updating sync settings:', settings)
    const response = await apiClient.post<SyncSettings>('/admin/settings/sync', settings)
    console.log('✅ Updated sync settings:', response.data)
    return response.data
  }
}